import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import { Input } from "shared/ui/Input";
import styles from "./UserInfoModal.module.scss";

export const UserInfoModal = ({ isModalOpen, open, close, toggle, record }) => {
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        <p className={styles.modalContent__title}>Информация о клиенте</p>
        <div className={styles.formWrapper__form}>
          {record?.companyName ? (
            <div className={styles.formWrapper__formItem}>
              <p className={styles.formWrapper__label}>
                Наименование организации
              </p>
              <Input
                type="text"
                placeholder={record?.companyName}
                className={styles.formWrapper__input}
                disabled={true}
              />
            </div>
          ) : (
            <></>
          )}

          <div className={styles.formWrapper__formItem}>
            <p className={styles.formWrapper__label}>ФИО</p>
            <Input
              type="text"
              placeholder={record?.fio}
              className={styles.formWrapper__input}
              disabled={true}
            />
          </div>

          <div className={styles.formWrapper__formItem}>
            <p className={styles.formWrapper__label}>Номер телефона</p>
            <Input
              type="text"
              placeholder={record?.phoneNumber}
              className={styles.formWrapper__input}
              disabled={true}
            />
          </div>

          <div className={styles.formWrapper__formItem}>
            <p className={styles.formWrapper__label}>Электронная почта</p>
            <Input
              type="text"
              placeholder={record?.email}
              className={styles.formWrapper__input}
              disabled={true}
            />
          </div>
        </div>
        <div className={styles.modalContent__buttonBlock}>
          <div className={styles.modalContent__button}>
            <Button variant="primary" size="large" onClick={close}>
              Закрыть
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
